module.exports = __webpack_public_path__ + "static/media/vegitables_25.d15ddcf3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_25.csv
// module id = 608
// module chunks = 0